(function() {
  var m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2,4})?)(?:\/|$)/);
  if (!m) return;
  var prefix = "/" + m[1];
  function fix(href) {
    if (!href) return href;
    if (/^https?:\/\//.test(href)) {
      try {
        var u = new URL(href);
        if (u.hostname !== window.location.hostname) return href;
        href = u.pathname + u.search + u.hash;
      } catch(e) { return href; }
    }
    if (/^(\/\/|#|mailto:|tel:|javascript:)/.test(href)) return href;
    if (href.indexOf("/cdn/") === 0) return href;
    if (href.indexOf(prefix + "/") === 0 || href === prefix) return href;
    if (href.indexOf("/") === 0) return prefix + href;
    return href;
  }
  function fixEl(a) {
    var orig = a.getAttribute("href");
    var fixed = fix(orig);
    if (fixed !== orig) a.setAttribute("href", fixed);
  }
  function fixAll() { document.querySelectorAll("a[href]").forEach(fixEl); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fixAll);
  } else { fixAll(); }
  window.addEventListener("load", fixAll);
  new MutationObserver(function(muts) {
    muts.forEach(function(mu) {
      mu.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        if (n.tagName === "A") fixEl(n);
        if (n.querySelectorAll) n.querySelectorAll("a[href]").forEach(fixEl);
      });
    });
  }).observe(document.documentElement, {childList: true, subtree: true});
  document.addEventListener("click", function(e) {
    var a = e.target.closest("a[href]");
    if (!a) return;
    var orig = a.getAttribute("href");
    var fixed = fix(orig);
    if (fixed !== orig) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = fixed;
    }
  }, true);
})();
